// src/pages/UsageAbout.jsx
import React, { Component, Fragment } from "react";
import { Helmet } from 'react-helmet';
import HeaderOne from '../components/header/HeaderOne';
import Footer from '../components/footer/Footer';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiHeart, FiGithub, FiInfo } from "react-icons/fi";
import Breadcrumb from "../components/common/Breadcrumb";

// You can replace these with actual image paths if you have them
const projectLogo = require('../assets/images/eidocell/logo.png'); // Example: a larger version of your logo
// const teamPhotoPlaceholder = require('../assets/images/team/team-placeholder-group.jpg'); // Example placeholder

class AboutPage extends Component {
    render() {
        return (
            <Fragment>
                <HeaderOne />

                <Breadcrumb title={'About Eidocell'} />

                <div className="main-content-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="about-page-content text-white">
                            

                                    <section id="what-is-eidocell" className="mb--40 content-section">
                                        <h2 className="section-heading"><FiInfo className="heading-icon" /> What is Eidocell?</h2>
                                        <p>
                                            Analyzing thousands of images at the single-cell level can be a challenging and time-consuming task. 
                                            Moreover, existing software solutions are often either proprietary, require programming skills, 
                                            or are not tailored to the data format where an event corresponds to a single image.
                                            Eidocell aims to fill this gap by providing an intuitive graphical user interface (GUI) 
                                            combined with modern image processing and machine learning capabilities. The goal is to ease the integration of
                                            modern computational methods and design into an open-code project that could be used or developed further by anyone.
                                        </p>
                                    </section>

                                    <section id="why-eidocell" className="mb--40 content-section">
                                        <h2 className="section-heading"><FiHeart className="heading-icon" /> Motivation</h2>
                                        <p>
                                            The primary motivation is to simplify sorting of large collections of images and their analysis. In the age of data the least time should be spent
                                            on the least intellectually-demanding tasks. Eidocell is created to:
                                        </p>
                                        <ul>
                                            <li><strong>Simplify Workflow:</strong> Focus on single images and semi-automated sorting. All the necessary tools to achieve quantitative results for each image are present.</li>
                                            <li><strong>Accelerate Discovery:</strong> By making analysis faster and comparably robust, we hope to help researchers gain insights from their data more quickly.</li>
                                            <li><strong>Foster Collaboration:</strong> Being open-source, we encourage community contributions and creation of new projects in similar direction.</li>
                                        </ul>
                                    </section>

                                    <section id="who-we-are" className="mb--40 content-section">
                                        <h2 className="section-heading">Development</h2>
                                        <p>
                                            Eidocell (website and main app) is developed and maintained by an individual (Andrey Kurenkov) with a background in computer science and machine learning.
                                        </p>
                                        {/* Optional: Add a placeholder for a team photo or individual photos later */}
                                        {/* 
                                        <div className="text-center my--30">
                                            <img src={teamPhotoPlaceholder} alt="The Eidocell Team" style={{maxWidth: '400px', borderRadius: '8px', border: '2px solid var(--accent-color)'}}/>
                                        </div>
                                        */}
                                        <p>
                                            If you're interested in getting involved or have questions, you can send an email <a href="mailto:andrey.kurenkov@nu.edu.kz" rel="noopener noreferrer">directly to me</a> (andrey.kurenkov@nu.edu.kz) or visit the <a href="https://github.com/your-repo/eidocell" target="_blank" rel="noopener noreferrer">GitHub repository</a>.
                                        </p>
                                    </section>

                                    <section id="current-stage" className="mb--40 content-section disclaimer-section">
                                        <h2 className="section-heading">Current Stage & Disclaimer</h2>
                                        <div className="disclaimer-box">
                                            <p>
                                                <strong>Please Note:</strong> Eidocell is currently in its early stages of development. While I work diligently to create a stable and feature-rich release for multiple platforms, you may still encounter bugs or find that some features are unavailable or need refactoring.
                                            </p>
                                            <p>
                                                Your understanding, patience, and any feedback are appreciated and could be invaluable for further support of the project. Please report any issues or suggestions on our <a href="https://github.com/your-repo/eidocell/issues" target="_blank" rel="noopener noreferrer">GitHub Issues page</a>.
                                            </p>
                                            <p>
                                                Thank you for your support!
                                            </p>
                                        </div>
                                    </section>

                                    <div className="text-center mt--50">
                                        <a href="https://github.com/xuzzu/eidocell" target="_blank" rel="noopener noreferrer" className="ar-button style-flat secondary">
                                            <FiGithub /> Visit us on GitHub
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
            </Fragment>
        )
    }
}


export default AboutPage;
